import {action, computed, makeObservable, observable} from "mobx";
import Feature from "../Feature";
import ChatWidgetPointer from "./ChatWidgetPointer";
import sdpChatbotMascot from "../../media/sdp-chatbot-mascot.jpg";
import saporeDiPaneLogo from "../../media/sapore-di-pane-logo.jpeg";

export default class NewsFeature extends Feature {

    constructor(application) {
        super(application);
        this._newsToShow = [];
        this._wasDismissed = false;

        makeObservable(this, {
            _newsToShow: observable.ref,
            _wasDismissed: observable,
            isOpen: computed,
            newsToShow: computed,
            dismiss: action,
        });
    }

    load() {
        const session = this._application.session();
        const today = this._todayAtLocalMidnight();
        this._newsToShow = this._newsToShowFrom(this._backofficeNews(), session.lastShownNewsDatesByNewsId(), today);
        this.finishLoading();
    }

    get isOpen() {
        return this._newsToShow.length > 0 && !this._wasDismissed;
    }

    get newsToShow() {
        return this._newsToShow;
    }

    dismiss() {
        this._wasDismissed = true;
        this._application.session().markNewsAsShown(this._newsToShow.map((news) => news.id), this._todayAtLocalMidnight());
    }

    _backofficeNews() {
        return [
            {
                id: 'chatbot-assistant',
                title: 'Llegó el SDP Chatbot',
                body: 'Es el nuevo asistente del portal: usalo para resolver dudas sobre ' +
                    'funcionalidades y procesos. Lo encontrás en el botón de chat abajo a la derecha.',
                illustration: sdpChatbotMascot,
                illustrationAlt: 'Mascota del SDP Chatbot, un robot panadero con sombrero de paja y una espiga de trigo',
                startDate: '2026-08-19',
                durationInDays: 14,
                frequencyInDays: 3,
                pointer: ChatWidgetPointer,
            },
            {
                id: 'free-order-mandatory-comment',
                title: 'Pedidos sin cargo con comentario',
                body: 'Los pedidos sin cargo ahora necesitan un comentario. Lo cargás al crear el pedido y podés ' +
                    'editarlo desde la pantalla del pedido, debajo de los artículos. El que autoriza lo ve junto ' +
                    'al resto de los datos.',
                illustration: saporeDiPaneLogo,
                illustrationAlt: 'Logo de Sapore di Pane',
                startDate: '2026-09-23',
                durationInDays: 14,
                frequencyInDays: 3,
            },
        ];
    }

    _newsToShowFrom(catalog, lastShownDatesByNewsId, today) {
        return catalog.filter((news) => this._newsShouldBeShown(news, lastShownDatesByNewsId, today));
    }

    _newsShouldBeShown(news, lastShownDatesByNewsId, today) {
        const lastShownDateString = lastShownDatesByNewsId[news.id];
        const wasNeverShown = !lastShownDateString;
        const frequencyWindowHasElapsed = wasNeverShown
            || this._daysSince(this._parseYearMonthDayDate(lastShownDateString), today) >= news.frequencyInDays;
        return this._isWithinWindow(news, today) && frequencyWindowHasElapsed;
    }

    _isWithinWindow(news, today) {
        const startDate = this._parseYearMonthDayDate(news.startDate);
        const endDate = this._addDays(startDate, news.durationInDays);
        return today >= startDate && today < endDate;
    }

    _daysSince(aDate, anotherDate) {
        const millisecondsPerDay = 24 * 60 * 60 * 1000;
        return Math.round((anotherDate.getTime() - aDate.getTime()) / millisecondsPerDay);
    }

    _addDays(aDate, numberOfDays) {
        return new Date(aDate.getFullYear(), aDate.getMonth(), aDate.getDate() + numberOfDays);
    }

    _parseYearMonthDayDate(yearMonthDayString) {
        const [year, month, day] = yearMonthDayString.split('-').map(Number);
        return new Date(year, month - 1, day);
    }

    _todayAtLocalMidnight() {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }
}
